import styles from './documents-block.module.css';
import DocumentFolder from '../parts/DocumentFolder';
import { Grid, GridItem } from '@forma/forma-ui-kit';

const DocumentsBlock = ({ documents }) => {
  return (
    <Grid className={styles.root} columns={3}>
      {documents.map((elem) => (
        <GridItem key={elem.id}>
          <DocumentFolder
            title={elem.name}
            docs={elem.templates}
            idFolder={elem.id}
            {...elem}
          />
        </GridItem>
      ))}
    </Grid>
  );
};

export default DocumentsBlock;
